"use strict";

exports.__esModule = true;
exports.ColumnFilter = ColumnFilter;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _DropdownCheckboxList = require("../DropdownCheckboxList");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function getFilterItemPredicate(_ref) {
  var id = _ref.id,
    dict = _ref.dict,
    formatter = _ref.formatter;
  return function (query, item) {
    return dict[id] && dict[id][item] ? dict[id][item].toLowerCase().includes(query.toLowerCase()) :
    // $FlowFixMe
    (formatter({
      value: item
    }) || "").toString().toLowerCase().includes(query.toLowerCase());
  };
}
function getFilterText(_ref2, item) {
  var id = _ref2.id,
    dict = _ref2.dict,
    formatter = _ref2.formatter;
  return dict[id] ? dict[id][item] : formatter({
    value: item
  }, true);
}
function getItemLabel(_ref3, item) {
  var id = _ref3.id,
    dict = _ref3.dict;
  return dict[id] ? item : null;
}
function ColumnFilter(id, devicesMap, statesMap, activitiesMap, formatter, data) {
  var dict = {
    device: devicesMap,
    activity: activitiesMap,
    state: statesMap
  };
  var items = Object.values(data.reduce(function (acc, item) {
    if (!acc[item[id]]) {
      acc[item[id]] = item[id];
    }
    return acc;
  }, {}));
  var itemPredicate = getFilterItemPredicate({
    id: id,
    dict: dict,
    formatter: formatter
  });
  return function (_ref4) {
    var _ref4$filter = _ref4.filter,
      filter = _ref4$filter === void 0 ? {
        value: []
      } : _ref4$filter,
      onChange = _ref4.onChange;
    return /*#__PURE__*/_react["default"].createElement(_DropdownCheckboxList.DropdownCheckboxList, {
      selected: filter.value,
      items: items,
      itemPredicate: itemPredicate,
      renderItemText: function renderItemText(item) {
        return getFilterText({
          id: id,
          dict: dict,
          formatter: formatter
        }, item);
      },
      renderItemLabel: function renderItemLabel(item) {
        return getItemLabel({
          id: id,
          dict: dict
        }, item);
      },
      getKey: function getKey(item) {
        return item;
      },
      onSelect: function onSelect(selected) {
        return onChange(selected);
      },
      usePortal: false
    }, /*#__PURE__*/_react["default"].createElement(_core.Button
    // $FlowFixMe
    , {
      text: filter.value.length ? formatter({
        value: filter.value[0]
      }, true) + ", ..." : "Select",
      rightIcon: _icons.IconNames.DOUBLE_CARET_VERTICAL
    }));
  };
}